import React from 'react';
import { useRouter } from 'found';

/**
 * Debounced search handler for list pages using the Table component's
 * onSearch prop. `buildUrl` receives the query text and should return the
 * target URL with the page offset reset to 0; the push happens after the
 * user stops typing for `debounceTime` ms.
 */
export default function useTableSearch(
  buildUrl: (query: string) => string,
  debounceTime = 400
) {
  const { router } = useRouter();
  const debouncer = React.useRef<number>();

  // Cancel any pending push if the page unmounts
  React.useEffect(() => () => window.clearTimeout(debouncer.current), []);

  return (query: string) => {
    window.clearTimeout(debouncer.current);
    debouncer.current = window.setTimeout(() => {
      router.push(buildUrl(query));
    }, debounceTime);
  };
}
